<template>
  <div class="japan-affiliate-container">
    <div class="japan-affiliate-content">
      <div class="japan-affiliate-detail">
        <!-- Header -->
        <div :class="$vuetify.breakpoint.mdAndUp ? 'header mb-6' : 'header mb-4'">
          <div :class="$vuetify.breakpoint.mdAndUp ? 'header-title mb-2' : 'header-title mb-1'">
            구매력 있는 인플루언서 연결
          </div>

          <div :class="$vuetify.breakpoint.mdAndUp ? 'logo-section mb-4' : 'logo-section mb-2'">
            <div class="world-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                :width="$vuetify.breakpoint.mdAndUp ? '22' : '15'"
                :height="$vuetify.breakpoint.mdAndUp ? '22' : '15'"
                viewBox="0 0 22 22"
                fill="none">
                <path
                  d="M11 19.75C15.8325 19.75 19.75 15.8325 19.75 11C19.75 6.16751 15.8325 2.25 11 2.25C6.16751 2.25 2.25 6.16751 2.25 11C2.25 15.8325 6.16751 19.75 11 19.75Z"
                  stroke="white"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M11 2.25C8.75321 4.60913 7.5 7.74215 7.5 11C7.5 14.2579 8.75321 17.3909 11 19.75C13.2468 17.3909 14.5 14.2579 14.5 11C14.5 7.74215 13.2468 4.60913 11 2.25Z"
                  stroke="white"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M2.25 11H19.75"
                  stroke="white"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <h1 class="main-title">일본 어필리에이트</h1>
          </div>

          <p class="description">
            일본의 구매력 있는 인플루언서를 연결하여, <span class="desktop"></span>마케팅 효율을 평균 500% 개선합니다.
          </p>
        </div>

        <!-- Process Section -->
        <div class="process-section">
          <h3 :class="$vuetify.breakpoint.mdAndUp ? 'process-title mb-4' : 'process-title mb-2'">
            일본 시장 진출 전략
          </h3>

          <div class="process-steps">
            <div class="step-item">
              <v-icon color="#3895FF" size="24">mdi-numeric-1-box</v-icon>
              <div class="step-content">
                <p>일본 현지 문화 맞춤형 기획</p>
              </div>
            </div>

            <div class="step-item">
              <v-icon color="#3895FF" size="24">mdi-numeric-2-box</v-icon>
              <div class="step-content">
                <p>일본 SNS 전채널 대응</p>
              </div>
            </div>

            <div class="step-item">
              <v-icon color="#3895FF" size="24">mdi-numeric-3-box</v-icon>
              <div class="step-content">
                <p>판매 성과에 따른 광고비 정산</p>
              </div>
            </div>

            <div class="step-item">
              <v-icon color="#3895FF" size="24">mdi-numeric-4-box</v-icon>
              <div class="step-content">
                <p>성과 모니터링</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="japan-affiliate-image">
        <img
          v-if="$vuetify.breakpoint.mdAndUp"
          width="100%"
          height="100%"
          src="@/assets/img/campaign/export-voucher/japan-desktop.png"
          alt="japan-affiliate-image" />
        <img
          v-else
          width="100%"
          height="100%"
          src="@/assets/img/campaign/export-voucher/japan-mobile.png"
          alt="japan-affiliate-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shortformMarketingDetail',
};
</script>

<style scoped lang="scss">
.japan-affiliate-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f9fbff;
  padding: 100px 16px;

  @media (max-width: 960px) {
    padding: 56px 16px;
  }
}

.japan-affiliate-content {
  width: 100%;
  max-width: 1072px;
  display: flex;
  gap: 40px;

  @media (max-width: 960px) {
    flex-direction: column;
    gap: 16px;
  }
}

.japan-affiliate-detail {
  display: flex;
  flex-direction: column;
}

.header {
  margin-bottom: 48px;
}

.header-title {
  color: #f53c4b;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px; /* 155.556% */

  @media (max-width: 960px) {
    font-size: 14px;
    line-height: 24px;
  }
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.world-icon {
  width: 42px;
  height: 42px;
  background: linear-gradient(135deg, #a855f7 0%, #6366f1 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 960px) {
    width: 30px;
    height: 30px;
  }
}

.main-title {
  color: #21232e;
  text-align: center;
  font-size: 30px;
  font-weight: 800;
  line-height: 42px; /* 140% */

  @media (max-width: 960px) {
    font-size: 24px;
    line-height: 30px;
  }
}

.description {
  color: #4b5563;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  @media (max-width: 960px) {
    font-size: 14px;
    line-height: 24px; /* 171% */
  }
}

.process-section {
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 480px;

  @media (max-width: 960px) {
    width: 100%;
    padding: 16px;
  }
}

.process-title {
  color: #1b2b43;
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.6px;
}

.process-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.step-item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #f9fbff;
  border-radius: 8px;

  @media (max-width: 960px) {
    padding: 8px;
    gap: 8px;
  }
}

.step-content {
  display: flex;
  align-items: center;
  gap: 4px;

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.step-content h4 {
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px; /* 150% */
}

.step-content p {
  color: #4b5563;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
}

.japan-affiliate-image {
  width: 100%;
  max-width: 552px;
  max-height: 495px;

  @media (max-width: 960px) {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
